import { TableCell } from '@enechain/ecloud-designsystem'

type Props = {
  /** メモ / JEPX 自由記述欄の値。 未設定と空文字は「—」で出す。 */
  value: string | undefined
  /** 列幅。 design `.col-memo` は max-width に列フロアを合わせているので、 minWidth / maxWidth に同じ値を置く。 */
  width: string
}

/**
 * 入札一覧のメモ 2 欄 (メモ・JEPX 自由記述欄) のセル。 長文は省略し、 hover で全文を出す
 * (design `.col-memo` 準拠)。 スポット (通常・ブロック) と時間前の入札一覧が同じ見た目を
 * 共有する。
 */
export const BidMemoCell = ({ value, width }: Props): React.ReactElement => (
  <TableCell
    minWidth={width}
    maxWidth={width}
    color="Text.midEmphasis"
    css={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}
    title={value}
  >
    {value !== undefined && value !== '' ? value : '—'}
  </TableCell>
)
